<template>
    <div>
        <template v-if="viewPage == true && leaveCrud == true">
            <form id="" @submit.prevent="updateCompanyPartialLeaveData">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left"> Edit Company Partial Leave </h1>
                </div>
                <div class="company-main">
                    <div class="company-inner">
                        <div class="form-group">
                            <label class="label block-label"> Title  <em class="required">*</em> </label>
                            <input v-model="form.title" type="text" name="title" class="form-control" :class="{ 'is-invalid': form.errors.has('title') }">
                            <has-error :form="form" field="title"></has-error>
                        </div>
                        <div class="form-group">
                            <label class="label block-label"> Hours  <em class="required">*</em> </label>
                            <input v-model="form.hours" type="text" name="hours" onkeypress="return event.charCode >= 48 && event.charCode <= 57" class="form-control" :class="{ 'is-invalid': form.errors.has('hours') }">
                            <has-error :form="form" field="hours"></has-error>
                        </div>
                        <div class="form-group">
                            <label class="label block-label"> Gender <em class="required">*</em></label>
                            <select v-model="form.gender" name="gender" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('gender') }">
                                <option value="MALE">Male</option>
                                <option value="FEMALE">Female</option>
                                <option value="BOTH">Both</option>
                            </select>
                            <has-error :form="form" field="gender"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Leave Types <em class="required">*</em></label>
                            <select v-model="form.leave_types" name="leave_types[]" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('leave_types') }" multiple>
                                <option v-for="leave in leaves" :value="leave.id+','+leave.title">{{leave.title}}</option>
                            </select>
                            <has-error :form="form" field="leave_types"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Employment Types <em class="required">*</em></label>
                            <select v-model="form.employment_types" name="employment_types[]" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('employment_types') }" multiple>
                                <option value="PERMANENT">Permanent</option>
                                <option value="INTERN">Intern</option>
                                <option value="CONTRACTUAL">Contractual</option>
                                <option value="PROBATION">Probation</option>
                                <option value="PIECE_RATE">Piece Rate</option>
                            </select>
                            <has-error :form="form" field="employment_types"></has-error>
                        </div>
                        <div class="form-group">
                            <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                            <router-link to="/companyPartialLeaves" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template v-else-if="viewPage === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="viewPage === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                viewPage: null,
                leaveCrud: false,
                form: new Form({
                    'title':'',
                    'hours':'',
                    'gender':'',
                    'leave_types':[],
                    'employment_types':[],
                    'id' : this.$route.params.id,
                }),
                leaves:[]
            }
        },

        mounted(){
            this.$Progress.start();
            this.can('company_partial_leaves|crud_company_partial_leaves').then(result => {
                this.viewPage = result.company_partial_leaves;
                this.leaveCrud = result.crud_company_partial_leaves;
                this.$Progress.finish();
            }).then(result => {
                this.getSingleCompanyPartialLeave();
                $('.selectpicker').selectpicker();
            });
        },

        methods: {

            getSingleCompanyPartialLeave(){
                axios.get('/api/getCompanyPartialLeave/'+this.form.id)
                .then(res => {
                    if(res.status == 200){
                        this.leaves = res.data.companyLeaves;
                        let cpl = res.data.companyPartialLeave;
                        this.form.title = cpl.title;
                        this.form.hours = cpl.hours;
                        this.form.gender = cpl.gender;
                        var arr = JSON.parse(cpl.leave_types);
                        var result = arr.map(function(val) {
                           return val.id+','+val.value;
                        });
                        this.form.leave_types = result;
                        this.form.employment_types = JSON.parse(cpl.employment_types);
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                }).then(res =>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                });
            },

            updateCompanyPartialLeaveData() {
                this.$Progress.start();
                this.form.put('/api/updateCompanyPartialLeave')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Partial Leave updated successfully');
                        this.$router.push('/companyPartialLeaves');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    }
                })
                .catch(err => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            }

        }

    }
</script>
